import StreamVideoPlayer from '../../opentok/StreamVideoPlayer';

export default class PartnerRotatorSlide extends BaseSlide /*  Base is interconnected with le admin */ {
  mDiv: JQuery<HTMLElement>;
  isDragging: boolean;
  mPlayer: StreamVideoPlayer;
  hasPlayed: boolean;

  generateHtml(): void {
    let isLocked = false;
    if (
      (App.INSTANCE.CurrentUser.IsLoggedIn() == false || this.mContent.hasAccess() == false) &&
      !this.mContent.ContainsTagName('allow video preview')
    ) {
      isLocked = true;
    }

    var aStruct = {
      style: 'partner_rotator_slide',
      children: !isLocked && [
        {
          style: 'name_container',
          children: [{ style: 'name', interior: this.mStruct.title }],
        },
      ],
    };

    this.mDiv = $(HGEN.tree(aStruct));

    this.isDragging = false;

    if (this.mStruct.type == null) {
      this.mStruct.type = 'image';
    }

    let hasVideo = true;
    let aContentType;
    let playerClass;
    switch (this.mStruct.type.toLowerCase()) {
      case 'amazonivs':
      case 'mp4-uploaded':
        playerClass = AmazonIVSPlayer;
        break;
      case 'brightcove':
        playerClass = BrightCoveVideo;
        break;
      case 'vimeo':
        playerClass = VimeoVideo;
        break;
      case 'wistia':
        playerClass = WistiaVideo;
        break;
      case 'youtube':
        playerClass = YouTubeVideo;
        break;
      case 'mp4':
        playerClass = VideoJSPlayer;
        aContentType = 'video/mp4';
        break;
      case 'external':
      case 'image':
      default:
        hasVideo = false;
        var div = $(
          HGEN.tree({
            style: 'background_image_container ui_relative ui_full_height',
            children: [
              {
                style: 'background_image cover_absolute',
                backgroundImage: App.INSTANCE.getImageSrc(this.mStruct.image || this.mStruct.img),
              },
              { style: 'background_gradient' },
            ],
          }),
        );
        this.mDiv.prepend(div);
        if (this.mStruct.url) {
          this.mStruct.navigation = 'external';
        }

        Environment.addTouchEvents(this.mDiv, () => {
          if (this.mConstructorParams.onClickedSlide != null) {
            this.mConstructorParams.onClickedSlide(this);
          }

          if (this.mConstructorParams.onViewPost != null) {
            this.mConstructorParams.onViewPost(this);
          }
        });
        break;
    }

    if (hasVideo) {
      Environment.addTouchEvents(this.mDiv, () => {
        if (this.mConstructorParams.onClickedSlide != null) {
          this.mConstructorParams.onClickedSlide(this);
        }
      });

      this.embedVideoPlayer(playerClass, this.mStruct.url, aContentType);
    }

    // added to keep the videos from starting on mousedown when panning the rotator
    this.mDiv
      .find('.video_overlay')
      .on('mousedown', e => {
        e.preventDefault();
        this.isDragging = false;
      })
      .on('mousemove', e => {
        this.isDragging = true;
      })
      .on('mouseup', e => {
        var wasDragging = this.isDragging;
        this.isDragging = false;
        if (App.INSTANCE.CurrentUser.IsLoggedIn() && this.mContent.hasAccess() && !wasDragging) {
          this.mDiv.find('.video_overlay').hide();
          this.mPlayer.mVideoPlayer.play();
        }
      });

    if (this.mStruct.title == null || this.mStruct.title.length == 0) {
      this.mDiv.find('.name_container').remove();
    }
  }

  embedVideoPlayer(aPlayerClass, aVideoId, aContentType = null): void {
    this.mPlayer = new StreamVideoPlayer({
      clickText: '',
      content: this.mContent,
      controls: true,
      autoPlay: false,
      contentType: aContentType ? aContentType : 'application/x-mpegURL',
      onPause: () => {
        this.mDiv.find('.video_overlay').show();
      },
      onTimeChanged: function () {},
      onWatched: function () {},
      onWatchedHalf: function () {},
      onWatchedFully: function () {},
      onWatchedSome: () => {
        if (!this.hasPlayed) {
          // Pause rotator when video starts playing
          this.hasPlayed = true;
          if (this.mConstructorParams.onClickedSlide != null) {
            this.mConstructorParams.onClickedSlide(this);
          }
        }
      },
      start: 0,
      videoId: aVideoId,
      videoPlayerClass: aPlayerClass,
    });

    let struct = $(
      HGEN.tree({
        style: 'video_slide_container cover_absolute',
        children: [{ style: 'embed_container' }, { style: 'video_overlay cover_absolute' }],
      }),
    );

    this.mDiv.prepend(struct);
    this.mPlayer.mVideoPlayer.appendPlayerTo(struct.find('.embed_container'));
    this.mDiv.addClass('video');
  }

  getHeight(trackWidth): number {
    var aBreakpoint = CrowdHub_App.INSTANCE.hbreakpoint();
    switch (aBreakpoint) {
      case CrowdHub_App.CONFIG.BREAKPOINT_PHONE:
        return trackWidth / 1.59;
        break;

      default:
        return 478;
        break;
    }
  }

  getPreferredWidth(trackWidth): number {
    var aBreakpoint = CrowdHub_App.INSTANCE.hbreakpoint();
    switch (aBreakpoint) {
      case CrowdHub_App.CONFIG.BREAKPOINT_TABLET:
        return screen.width - 25;
        break;
      default:
        return 700;
        break;
    }
  }

  onTransitionIn(): void {
    TweenMax.fromTo(
      this.mDiv.find('.name'),
      1,
      { opacity: 0, x: 15 },
      { delay: 0.4, opacity: 1, x: 0, ease: Power3.easeOut },
    );
  }

  onTransitionOut(): void {
    if (this.mPlayer && this.mPlayer.mVideo && this.mPlayer.mVideo.pauseVideo) {
      this.mPlayer.mVideo.pauseVideo();
    }
    if (this.mPlayer && this.mPlayer.mVideo && this.mPlayer.mVideo.pause) {
      this.mPlayer.mVideo.pause();
    }
    if (this.mPlayer && this.mPlayer.mPlayer) {
      this.mPlayer.mPlayer.pause();
    }
    if (this.mPlayer && this.mPlayer.mVideoPlayer) {
      this.mPlayer.mVideoPlayer.pause();
    }
  }

  setSize(aWidth, aHeight): void {
    BaseSlide.prototype.setSize.call(this, aWidth, aHeight);
  }
}
